/* internal */
import { useBlockProps, RichText } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

export default function save( { attributes } ) {
		
	const { backgroundColor, content, title, speed} = attributes;	
	const blockProps = useBlockProps.save({className: speed});

	return (			
			<div { ...blockProps }
				style={ { backgroundColor: backgroundColor  } }
			>
			    <RichText.Content 
					tagName="div" 
					value={ title } 
                    className='title'
					alt={__('Here enter a title','hide-or-toggle') }
					title={__('Click here to toggle content','hide-or-toggle') }
					/>
           		<RichText.Content 
					tagName="div" 
					value={ content } 
                    className='hidden'
					alt={__('Here the content','hide-or-toggle') }
					/>
                
			</div>
		);
	
	}
